import type { GeneratedDocumentItem } from "../services/naraDoor";

export type ReportFormat = "pdf" | "html_page" | "html_bundle";

export const REPORT_FORMATS: ReportFormat[] = ["pdf", "html_page", "html_bundle"];

const FINISHED_STATUSES = new Set(["success", "completed", "ready"]);

function isFinished(item: GeneratedDocumentItem): boolean {
  const finishedStatus = !item.status || FINISHED_STATUSES.has(item.status);
  return finishedStatus && !!item.download_url;
}

/** Newest finished row per output format. Items are expected newest-first; absent format = "pdf". */
export function selectLatestReports(
  items: GeneratedDocumentItem[]
): Partial<Record<ReportFormat, GeneratedDocumentItem>> {
  const result: Partial<Record<ReportFormat, GeneratedDocumentItem>> = {};
  for (const item of items) {
    const format = item.output_format ?? "pdf";
    if (result[format] || !REPORT_FORMATS.includes(format) || !isFinished(item)) {
      continue;
    }
    result[format] = item;
  }
  return result;
}
